function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(variant_id, quantity, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity='+quantity+'&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.removeItem = function(variant_id, callback) {
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=0&id='+variant_id,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                Shopify.onCartUpdate(cart);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            Shopify.onError(XMLHttpRequest, textStatus);
        }
    };

    $.ajax(params);
}

Shopify.addItem = function(variant_id, quantity, callback, input = null) {
    var quantity = quantity || 1;
    var target = document.querySelector('[data-quickshop] .is-loading') || document.querySelector('[data-btn-addtocart].is-loading');
    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
        },
        error: function(XMLHttpRequest, textStatus) {
            // console.log(XMLHttpRequest)
            var message = window.cartStrings.addProductOutQuantity2;
            if (input.length > 0) {
                var maxValue = parseInt(input.attr('data-inventory-quantity'));
                message = getInputMessage(maxValue)
                input.val(maxValue)
            } 
            
            Shopify.onError(XMLHttpRequest, textStatus, message);
            target?.classList.remove('is-loading');
        }
    };
    $.ajax(params);
}

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        // if (window.innerWidth >= 767) {
        //     showWarning(data.message + '(' + data.status  + '): ' + data.description, warningTime);
        // } else {
            showWarning(data.message + ': ' + message, warningTime);
        // }
    } else {
        // if (window.innerWidth >= 767) {
        //     showWarning('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.', warningTime);
        // } else {
            showWarning('Error : ' + message, warningTime);
        // }
    }
}

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = el_input.dataset.inventoryQuantity;
        const outOfStockOrder = el_input.dataset.inventoryPolicy;

        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal < 0 ) {
            var newVal = 1
        }

        if (newVal > inStockNumber && outOfStockOrder != "continue") {
            const message = getInputMessage(inStockNumber);
            showWarning('message', warningTime);
            var newVal = inStockNumber
        }

        el_input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);          
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
    onButtonClick(event) {
        event.preventDefault();
        let el_input = event.target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = el_input.dataset.inventoryQuantity;
        const outOfStockOrder = el_input.dataset.inventoryPolicy;

        if (event.target.classList.contains('plus')) {
            var newVal = value + 1;
        } else {
            var newVal = value - 1;
        }

        if (newVal < 0 ) {
            var newVal = 1
        }

        if (newVal > inStockNumber && outOfStockOrder != "continue") {
            const message = getInputMessage(inStockNumber);
            showWarning(message, warningTime);
            var newVal = inStockNumber
        }
        
        el_input.value = newVal;
        this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.setAttribute('value', newVal);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
})

function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

// The quantity discounts of OC Quantity Breaks (Orichi) are only displayed in the cart: Orichi
// applies them at checkout through a draft order created by its own checkout call, which it
// starts on any `.button-checkout` click. Our checkout buttons first update the cart, so they
// keep the click to themselves and run the whole checkout here, one attempt at a time: our cart
// updates, then Orichi's checkout. Once the cart has shown an Orichi discount, the customer is never
// sent to the full-price checkout: a failed attempt ends with a message, and they can retry (DIA1-11).
let checkoutAttempt = null

async function proceedToCheckout(event, { button = null, checkoutUrl = '/checkout', prepareCart = async () => true } = {}) {
    if (checkoutAttempt) return
    const attempt = { button }
    checkoutAttempt = attempt
    if (button) button.disabled = true
    // Before our cart updates: they can make Orichi recalculate, which clears its discount data
    noteOrichiDiscount()

    // After a back/forward cache restore, a newer attempt may have replaced this one
    const isCurrent = () => checkoutAttempt === attempt
    const wait = (ms, value) => new Promise((resolve) => setTimeout(() => resolve(value), ms))

    // A cart request that never answers would keep both checkout buttons locked: reload instead
    const cartReady = await Promise.race([
        Promise.resolve().then(prepareCart).catch((error) => {
            console.error('[Checkout] Cart update failed', error)
            return false
        }),
        wait(30000, 'timeout')
    ])
    if (!isCurrent()) return
    if (cartReady === 'timeout') return window.location.reload()
    if (!cartReady) return endCheckoutAttempt()

    // In the first seconds after the page loads, Orichi's script (its app embed is on the page) or its
    // settings may still be on their way
    const orichiLoading = () => !window.OrichiQuantitySettingInfo
        && (typeof window.OrichiCheckOutBound === 'function' || typeof window.orichiDiscount !== 'undefined')
    while (orichiLoading() && performance.now() < 8000) {
        await wait(100)
    }
    if (!isCurrent()) return

    // Orichi missing, or not running (its server didn't answer when the page loaded): the cart shows
    // no Orichi price, so the theme's own checkout charges what the customer sees
    if (typeof window.OrichiCheckOutBound !== 'function' || !window.OrichiQuantitySettingInfo) {
        window.location.assign(checkoutUrl)
        return
    }

    const retryMessage = window.cartStrings?.error || 'Une erreur est survenue. Veuillez réessayer.'
    noteOrichiDiscount()
    const orichiState = await refreshOrichiCart()
    if (!isCurrent()) return
    if (orichiState !== 'ready') {
        // Orichi can't calculate the discounts now. If this page never showed one, the theme's checkout
        // charges what the customer saw. Otherwise they retry rather than pay the full price: right away,
        // or after a reload when Orichi stays busy for good (one of its refreshes hangs).
        if (!orichiDiscountSeen) {
            window.location.assign(checkoutUrl)
            return
        }
        if (orichiState === 'stuck') return window.location.reload()
        return endCheckoutAttempt(retryMessage)
    }
    noteOrichiDiscount()

    // Like Orichi's own click handler: its purchase-limit popup instead of the checkout
    if (window.o$ && window.OrichiQuantityButtonCheckOut && window.o$(window.OrichiQuantityButtonCheckOut).hasClass('OrichiDiscountLimitPopup')) {
        window.OrichiDiscountShowModal?.(window.OrichiDiscountPopupContent, true)
        return endCheckoutAttempt()
    }

    let leftPage = false
    let leavingAt = 0
    window.addEventListener('beforeunload', () => { leavingAt = Date.now() }, { once: true })
    window.addEventListener('pagehide', () => { leftPage = true }, { once: true })

    // Orichi redirects to the draft order, or to /checkout when nothing is discounted
    const handedOverAt = Date.now()
    window.OrichiCheckOutBound(event)

    // Keep the attempt locked while Orichi's request runs: a retry would send a second request, and
    // both answers would redirect. Only a reload drops a request that hangs.
    while (window.OrichiQuantityCheckoutInProcess && !leftPage) {
        if (Date.now() - handedOverAt > 60000) return window.location.reload()
        await wait(250)
    }

    // Orichi starts its redirect within 200 ms of the answer. Once the next page is loading, give it
    // time; with no redirect at all, Orichi has given up and the customer can retry.
    const answeredAt = Date.now()
    while (!leftPage && Date.now() < (leavingAt ? leavingAt + 30000 : answeredAt + 5000)) {
        await wait(250)
    }
    if (!leftPage && isCurrent()) endCheckoutAttempt(retryMessage)
}

// Back from the checkout, the page can be restored from the back/forward cache: the attempt is over.
// Not a one-time listener, since the first pageshow comes as soon as the page has loaded.
window.addEventListener('pageshow', (event) => {
    if (!event.persisted || !checkoutAttempt) return
    window.OrichiQuantityCheckoutInProcess = 0
    endCheckoutAttempt()
})

// Whether this page has shown Orichi's prices: its discount data had a different total (Orichi's own
// test). A failed calculation clears that data, also when Orichi recalculates on its own after a cart
// change. Orichi draws its prices as soon as it has the data, so each change to the page, cart page or
// side cart, is checked while the data is still there.
let orichiDiscountSeen = false

function noteOrichiDiscount() {
    const discounts = window.OrichiQuantityListLimitPurchase
    if (discounts && Number(discounts.TotalPrice) !== Number(discounts.TotalPriceNew)) orichiDiscountSeen = true
    return orichiDiscountSeen
}

const orichiDiscountWatcher = new MutationObserver(() => {
    if (noteOrichiDiscount()) orichiDiscountWatcher.disconnect()
})

// Orichi only draws after its server answers, so after the page is parsed
function watchOrichiDiscount() {
    orichiDiscountWatcher.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchOrichiDiscount)
} else {
    watchOrichiDiscount()
}

function endCheckoutAttempt(errorMessage = '') {
    const button = checkoutAttempt?.button
    checkoutAttempt = null

    if (button) {
        // Same rule as the terms checkbox that enables the button (`data-target`)
        const terms = document.querySelector(`.global-checkbox--input[data-target="#${button.id}"]`)
        button.disabled = Boolean(terms && !terms.checked)
    }

    if (!errorMessage) return
    if (document.getElementById('halo-warning-popup')) {
        showWarning(errorMessage, warningTime)
    } else {
        window.alert(errorMessage)
    }
}

// Orichi builds the draft order from its own copy of the cart, refreshed shortly after each cart
// change. Wait until Orichi is idle (orichiCartInterval() does nothing while it is busy), refresh
// it so the draft gets our cart updates, and make sure it has discount data. Resolves 'ready',
// 'failed' (the customer can retry) or 'stuck' (Orichi can't recover without a reload).
async function refreshOrichiCart(timeout = 15000) {
    if (typeof window.orichiCartInterval !== 'function') return 'ready'

    const wait = (ms, value) => new Promise((resolve) => setTimeout(() => resolve(value), ms))

    // Orichi's own busy rule (with its 10 s escape), plus any discount calculation still running:
    // its limit checks start one on their own, and an older answer would overwrite a newer one
    const isOrichiBusy = () => window.OrichiCartIntervalRunning || window.OrichiQuantityGetCartInProcess
        || (window.OrichiQuantityInProcess && Date.now() - window.OrichiQuantityTimeProcess <= 10000)
    const waitUntilIdle = async () => {
        const startedAt = Date.now()
        while (isOrichiBusy()) {
            if (Date.now() - startedAt > timeout) return false
            await wait(50)
        }
        return true
    }

    // Orichi's cart request is synchronous and has no error callback: a failed one leaves the refresh
    // pending, and Orichi busy, for good. (A stalled one freezes the page until the browser gives up,
    // which no timeout can interrupt.)
    const refresh = async (recalculate = false) => {
        if (!(await waitUntilIdle())) return false
        // Orichi only recalculates the discounts when its copy of the cart changed: unknown forces it
        if (recalculate) window.OrichiQuantityCartInfo = null
        return Promise.race([window.orichiCartInterval().then(() => true), wait(timeout, false)])
    }

    try {
        if (!(await refresh())) return 'stuck'

        // A failed calculation is not retried while the cart is unchanged
        if (window.OrichiQuantityListLimitPurchase === null && !(await refresh(true))) return 'stuck'

        // The refresh may have started Orichi's limit checks
        if (!(await waitUntilIdle())) return 'stuck'
    } catch (error) {
        console.error('[Checkout] Orichi cart refresh failed', error)
        return 'failed'
    }

    // Without discount data (failed calculation), Orichi would skip the discount
    const hasDiscountData = !('OrichiQuantityListLimitPurchase' in window) || window.OrichiQuantityListLimitPurchase != null
    return hasDiscountData ? 'ready' : 'failed'
}
